/* Orient Tech — UI/UX Enhancement Layer (Phase 1)
   Reveal-on-scroll, as progressive enhancement.

   Safety model: the CSS hides .orient-reveal elements ONLY when <html> has
   the .orient-reveal-ready class. We add that class here exclusively when
   IntersectionObserver is supported and the user has not requested reduced
   motion — so if JS is off, unsupported, or the user prefers reduced motion,
   nothing is ever hidden. */
(function () {
  'use strict';

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced || !('IntersectionObserver' in window)) return;

  function init() {
    var targets = document.querySelectorAll('.orient-reveal');
    if (!targets.length) return;

    document.documentElement.classList.add('orient-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
